'use strict';

/**
 * Decoupled into separate function condition which identifies either renew switch can be enabled or not.
 * If not - renew state will be preserved (default one if user didn't specify it or user's choice).
 *
 * @returns {boolean}
 */
export default (period) => (period?.billing_period === 'Year' && period?.interval === 1)
        || period?.billing_period === 'Month';
